import React from 'react';
import * as PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button } from '@design-system-etat/dsfr-react';
import RoutesSupprimerArme from '../../../../armes/supprimer/routes';
import { getPath } from '../../../../../../utils/router';

const BoutonSupprimerArme = ({ armesSelectionnees }) => {
    const history = useHistory();

    const redirectionVersPageSupprimerArme = () => {
        const armesSelectionneesUuid = armesSelectionnees.map((element) => {
            return element.uniquid;
        });

        history.push({
            pathname: getPath(RoutesSupprimerArme),
            state: { listeArmes: armesSelectionneesUuid },
        });
    };

    return (
        <Button variant="primary" onClick={redirectionVersPageSupprimerArme}>
            Demander la suppression de l'arme
        </Button>
    );
};

BoutonSupprimerArme.propTypes = {
    armesSelectionnees: PropTypes.func.isRequired,
};

export default BoutonSupprimerArme;
